import React, { useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";
import { ModalAlert, ModalConfirm } from '../ModalSistema';
import "./listaSistemas.css";
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../../config/backend';

function ListaSistemas(props) {
    const [confirmDelete, setConfirmDelete] = useState({ show: false, codSis: null });
    const [alertSuccess, setAlertSuccess] = useState({ show: false, message: '' });

    const solicitarExclusao = (codSis) => {
        setConfirmDelete({ show: true, codSis });
    };

    const executarDeleteSistemas = async () => {
        const codSis = confirmDelete.codSis;
        setConfirmDelete({ show: false, codSis: null });
        if (codSis == null) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.delete(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas", {
                headers: { Authorization: `${token}` },
                data: { codSis }
            });
            setAlertSuccess({ show: true, message: "Sistema " + codSis + " deletado com sucesso!" });
        } catch (error) {
            console.error('Erro:', error);
        }
    };

    return (
        <div className="lista-wrapper">
        <ModalConfirm
            open={confirmDelete.show}
            onClose={() => setConfirmDelete({ show: false, codSis: null })}
            title="Excluir sistema"
            message={"Você realmente deseja excluir o sistema " + (confirmDelete.codSis ?? '') + "?"}
            confirmLabel="Sim, excluir"
            cancelLabel="Cancelar"
            onConfirm={executarDeleteSistemas}
            variant="danger"
        />
        <ModalAlert
            open={alertSuccess.show}
            onClose={() => { setAlertSuccess({ show: false, message: '' }); window.location.reload(); }}
            title="Sucesso"
            message={alertSuccess.message}
            labelOk="OK"
        />
            <table className="table table-modern align-middle">
                <thead>
                    <tr>
                        <th scope="col">Código</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Setor</th>
                        <th scope="col">Situação</th>
                        <th scope="col" width="80"></th>
                    </tr>
                </thead>
                <tbody>
                    {(props.arraySistemas || []).map((sistema, index) => {
                        const cod = sistema.codsis ?? sistema.CODSIS;
                        const sit = (sistema.sitsis ?? sistema.SITSIS ?? sistema.SLISIS ?? '').toString();
                        return (
                        <tr
                            key={cod != null ? cod : `row-${index}`}
                            className={props.onEdit ? 'table-row-clickable' : ''}
                            onClick={() => props.onEdit && props.onEdit(cod)}
                        >
                            <td>{cod}</td>
                            <td>
                                {props.onEdit ? (
                                    <button type="button" className="btn btn-link p-0" onClick={(e) => { e.stopPropagation(); props.onEdit(cod); }}>{sistema.nomsis ?? sistema.NOMSIS}</button>
                                ) : (
                                    <Link to={{ pathname: '/sistemas', state: { editId: cod } }}>{sistema.nomsis ?? sistema.NOMSIS}</Link>
                                )}
                            </td>
                            <td>{sistema.dessis ?? sistema.DESSIS}</td>
                            <td>{sistema.setsis ?? sistema.SETSIS ?? sistema.SCTSTS}</td>
                            <td>
                                <span className={`badge-pill ${sit === 'A' ? 'badge-ativo' : 'badge-inativo'}`}>
                                    {sit === 'A' ? 'Ativo' : 'Inativo'}
                                </span>
                            </td>
                            <td onClick={(e) => e.stopPropagation()}><button className="btn btn-danger btn-sm" onClick={() => solicitarExclusao(cod)} type="button" title="Excluir"><i className="fas fa-trash" /></button></td>
                        </tr>
                    );})}
                </tbody>
            </table>
        </div>
    );
}

export default ListaSistemas;
